// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {artifactMembershipNodeInputType} from './InfoDrawerArtifacts';
import {runNodeInputType} from './InfoDrawerRuns';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {
  extractArtifactMembershipNodeInput,
  extractRunNodeInputType,
  nodeType,
} from './LayoutDagUtils';
import {Artifact, Run} from './utils';

type DefaultNodeProps = {
  isSelected: boolean;
  isExpandedNode: boolean;
  setIsDrawerOpen: (val: boolean) => void;
  setDrawerType: (val: nodeType) => void;
  setArtifactMembershipNodeInput?: (
    val: artifactMembershipNodeInputType
  ) => void;
  setRunNodeInput?: (val: runNodeInputType) => void;
  type?: string;
  nodeName: string;
  artifact?: Artifact;
  run?: Run;
};

export const DefaultNode = ({
  isSelected,
  isExpandedNode,
  setIsDrawerOpen,
  setDrawerType,
  setArtifactMembershipNodeInput,
  setRunNodeInput,
  nodeName,
  type,
  artifact,
  run,
}: DefaultNodeProps) => {
  if (
    (artifact === undefined && run === undefined) ||
    (artifact !== undefined && run !== undefined)
  ) {
    return <></>;
  }
  return (
    <>
      <Tailwind style={{width: '100%', height: '100%'}}>
        <div
          className={`flex h-full w-full cursor-pointer items-center border border-solid py-[12px] pr-[8px] ${
            isSelected
              ? 'border-gold-400'
              : isExpandedNode
                ? 'border-teal-400'
                : 'border-moon-300'
          } flex-row gap-[8px] rounded-lg hover:border-teal-400`}
          onClick={() => {
            setIsDrawerOpen(true);
            setDrawerType(artifact ? nodeType.ARTIFACT : nodeType.RUN);
            if (
              artifact !== undefined &&
              setArtifactMembershipNodeInput !== undefined
            ) {
              setArtifactMembershipNodeInput(
                extractArtifactMembershipNodeInput(artifact)
              );
            } else if (run !== undefined && setRunNodeInput !== undefined) {
              setRunNodeInput(extractRunNodeInputType(run));
            }
          }}>
          <div
            className={`flex h-[48px] w-[48px] flex-none items-center justify-center rounded-l-lg ${
              artifact ? 'bg-[#D0E4FE]' : 'bg-[#C9F5E0]'
            }`}>
            <Icon
              className={`h-[18px] w-[18px] flex-none ${
                artifact ? 'text-blue-550' : 'text-green-550'
              }`}
              name={artifact ? 'versions-layers' : 'running-repeat'}
            />
          </div>
          <div className="flex-col overflow-hidden">
            <div className="flex flex-auto items-center">
              <div className="mr-[8px] overflow-hidden text-ellipsis whitespace-nowrap font-sans text-xs font-normal leading-normal text-moon-650">
                <Tooltip
                  content={type}
                  position="top center"
                  trigger={
                    <div className="black overflow-hidden	text-ellipsis	whitespace-nowrap font-sans text-[13px] font-normal leading-normal">
                      {(artifact ? 'Artifact' : 'Run') +
                        (type ? ' - ' + type : '')}
                    </div>
                  }></Tooltip>
              </div>
            </div>
            <div className="text-left">
              <Tooltip
                content={nodeName}
                position="top center"
                trigger={
                  <div className="black overflow-hidden	text-ellipsis	whitespace-nowrap font-sans text-[14px] font-normal leading-normal">
                    {nodeName}
                  </div>
                }></Tooltip>
            </div>
          </div>
        </div>
      </Tailwind>
    </>
  );
};
